export default __webpack_public_path__ + "static/media/control-white-icon.e55d89aa.png";